import { InsuranceDto } from '@maia/shared';
import { cardStyles, SectionWithHeader, SpecList } from '@maia/ui';
import { twMerge } from 'tailwind-merge';

type Props = {
  insurance: InsuranceDto;
};

export function ObjectInformationCard(props: Props) {
  const { insurance } = props;

  return (
    <SectionWithHeader title="Gegevens van het object">
      <div className={twMerge(cardStyles({ variant: 'outlined' }), 'p-20')}>
        <SpecList
          items={insurance.object?.specs.flatMap((spec) => {
            if (!spec.value) {
              return [];
            }
            return {
              title: spec.label,
              value: spec.value,
              isHalf: true,
            };
          })}
        />
      </div>
    </SectionWithHeader>
  );
}
